import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ReportAsset from "./components/ReportAsset";
import React, { Fragment, useEffect, useState } from "react";
import "./App.css";
import Auth from "./components/Auth/Auth";
import Login from "./components/Auth/Login";
import VerifyEmail from "./components/Auth/VerifyEmail";
import Register from "./components/Auth/Register";
import Home from "./components/Home/Home";

import { connect, useDispatch } from "react-redux";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import VerifyAccount from "./components/VerifyAccount/VerifyAccount";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import ResetSuccess from "./components/ResetSuccess/ResetSuccess";
import VerifyRegister from "./components/VerifyRegister/VerifyRegister";
import Error from "./components/Error";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BusinessUnitList from "./components/organisation/BusinessUnitList/BusinessUnitList";
import Empty from "./components/Empty/Empty";
import BusinessUnitHome from "./components/organisation/BusinessUnitHome";
import EmissionsHome from "./components/EmissionLog/EmissionsHome";
import EmissionList from "./components/EmissionLog/EmissionList/EmissionList";
import DashBoard from "./components/DashBoard/DashBoard";
import TargetList from "./components/Target/TargetList";
import TargetHome from "./components/Target/TargetHome";
import EmissionTarget from "./components/Target/AdvancedTargets/AdvancedEmissionTarget";
import FileUploadPage from "./components/FileUploadPage/FileUploadPage";
import CreateReport from "./components/Reports/CreateReport";
import AssetList from "./components/Assets/AssetList";
import AssetHome from "./components/Assets/AssetHome";
import { useSelector } from "react-redux";
import { setUsetiful } from "./usetiful-script";
import Employee from "./components/Employees/Employee";
import EmployeeList from "./components/Employees/EmployeeList";
import EmployeeHome from "./components/Employees/EmployeeHome";
import OnBoarding from "./components/OnBoarding";
import { getRbacPermissions } from "./services/rbacService";
import RbacRoute from "./components/common/Rbac/RbacRoute";
import HomePage from "./components/HomeModule/HomePage";
import {
  AUTH_REDUCER,
  SUBSCRIPTION_REDUCER,
  ORG_REDUCER,
  USER_REDUCER,
} from "./constants/enums";
import { getSubscriptionPermissions } from "./services/subscriptionService";
import SubscriptionLandingPage from "./components/Subscription/SubscriptionLandingPage";
import OrganisationInfomation from "./components/Settings/OrganisationInformation";
import OrganisationPreference from "./components/Settings/OrganisationPreference";
import SubscriptionSettings from "./components/Settings/SubscriptionSettings";
import Security from "./components/Settings/Security";
import CustomEmissionList from "./components/DataSource/CustomEmissionFactorList/CustomEmissionList";
import CustomEmissionCreation from "./components/DataSource/CustomEmissionCreation/CustomEmissionCreation";
import SupplierHome from "./components/Supplier/SupplierHome/SupplierHome";
import SupplierCreation from "./components/Supplier/SupplierCreation/SupplierCreation";
import SupplierRegistration from "./components/Auth/SupplierRegistration";
import CustomerHome from "./components/Customer/CustomerHome/CustomerHome";
import SourceEmissionFactor from "./components/DataSource/SourceEmissionFactor/SourceEmissionFactorList";
import { checkPermissions } from "./helper";
import ProjectAndOffsetsList from "./components/ProjectsAndOffsets/ProjectsAndOffsetsList";
import ProjectAndOffsetsCreation from "./components/ProjectsAndOffsets/ProjectsAndOffsetsCreation";
import { getSettingPreferences } from "./services/orgService";
import { getUserDetails } from "./services/userService";
import AuditList from "./components/Audit/AuditList";
import AuditCreation from "./components/Audit/AuditCreation";
import ExternalVerifierLogin from "./components/Auth/ExternalVerifierLogin";
import ExternalAuditSummary from "./components/EmissionLog/ExternalAuditSummary/ExternalAuditSummary";
import AuditSummaryHome from "./components/EmissionLog/ExternalAuditSummary/AuditSummaryHome";
import TrainingVideo from "./components/TrainingVideo/TrainingVideo";
import DataCollection from "./components/Customer/DataCollection/DataCollection";
import { SupplierBulkUpload } from "./components/Supplier/BulkUpload/SupplierBulkUpload";
import { DisclosureHome } from "./components/organisation/Disclosures/DisclosureHome";
import CategoryMapping from "./components/CategoryMapping/CategoryMapping";
// import axios from 'axios';

// axios.defaults.headers.common['test'] = "Abhi" ;

function App({ isLoggedIn }: { isLoggedIn: any }) {
  const isLogged = useSelector((state: any) => state.auth.token);
  const dispatch = useDispatch();
  const queryParameters = new URLSearchParams(window.location.search);
  const [openSubscription, setOpenSubscription] = useState(false);
  const [openSubscriptionDialog, setOpenSubscriptionDialog] = useState(false);
  console.log("isLogged", isLogged);
  const [rbacPerm, setRbacPerm] = useState<any>([]);
  const setRbacPermissions = (permissions: any) => {
    const perObj = {
      type: AUTH_REDUCER.SET_USER_PERMISSIONS,
      payload: permissions,
    };
    dispatch(perObj);
  };

  const setSubscriptionPermissions = (subscriptionRes: any) => {
    if (subscriptionRes?.data?.permissions.length) {
      let moduleList = subscriptionRes?.data?.addonPermissions.filter(
        (permission: any) => permission.addon_code?.includes("srm")
      ).length
        ? [
            { name: "SRM", usageLimit: null },
            { name: "SUPPLIER", usageLimit: null },
          ]
        : [];
      subscriptionRes.data.permissions = [
        ...subscriptionRes?.data?.permissions,
        ...moduleList,
      ];
    }
    dispatch({
      type: SUBSCRIPTION_REDUCER.SET_SUBSCRIPTION_RES,
      subscriptionPermissions: subscriptionRes?.data?.permissions || [],
      addonPermissions: subscriptionRes?.data?.addonPermissions || [],
      currentTermEndsAt: subscriptionRes?.data?.currentTermEndsAt || "",
      cardDetailsStatus: subscriptionRes?.data?.cardStatus || "Not Provided",
      subscription: subscriptionRes?.data || {},
      subscriptionApiCompleted: true,
    });
    let token = localStorage.getItem("token") || "";
    let userRole;
    if (token) {
      userRole = JSON.parse(atob(token?.split(".")[1])).iss.role;
    }
    if (
      (subscriptionRes?.data?.isExpired ||
        subscriptionRes?.data?.status === "unsubscribed") &&
      userRole != 5
    ) {
      setOpenSubscription(true);
      if (
        !(
          window.location?.pathname &&
          window.location?.pathname.includes("customers")
        )
      ) {
        setOpenSubscriptionDialog(true);
      }
    }
  };

  const handleSubscriptionDialogClose = () => {
    setOpenSubscriptionDialog(false);
    if (
      !(
        window.location?.pathname &&
        window.location?.pathname.includes("customers")
      )
    ) {
      window.location.href =
        window.location.origin + "/partners/customers/list";
    }
  };

  const checkSubscriptionDialogOnRouteChange = () => {
    setOpenSubscriptionDialog(
      openSubscription &&
        !(
          window.location?.pathname &&
          window.location?.pathname.includes("customers")
        )
    );
  };

  useEffect(() => {
    if (
      !queryParameters.get("website") &&
      (isLogged || localStorage.getItem("token"))
    ) {
      getRbacPermissions()
        .then((permissions) => {
          setRbacPermissions(permissions);
          setRbacPerm(permissions);
        })
        .catch((error) => {
          console.error("Error fetching RBAC permissions:", error);
        });

      getSubscriptionPermissions()
        .then((subscriptionRes) => {
          setSubscriptionPermissions(subscriptionRes);
        })
        .catch((error) => {
          console.error("Error fetching user subscription permissions:", error);
        });
      //for external verifier check
      const from_date =
        localStorage.getItem("from_date") && localStorage.getItem("from_date");
      !from_date &&
        getSettingPreferences(false).then((res) => {
          res?.data &&
            dispatch({
              type: ORG_REDUCER.SET_COMPANY_PREFERENCES,
              payload: res.data,
            });
        });
      !from_date &&
        getUserDetails().then((res) => {
          res?.data &&
            dispatch({
              type: USER_REDUCER.SET_USER_DETAILS,
              payload: res.data,
            });
        });
    }
  }, [isLogged]);

  useEffect(() => {
    if (
      queryParameters.get("isAutomation") &&
      !localStorage.getItem("isAutomation")
    ) {
      localStorage.setItem("isAutomation", "true");
    } else if (
      !localStorage.getItem("isAutomation") &&
      !queryParameters.get("website") &&
      rbacPerm?.length &&
      checkPermissions(["READ_USETIFUL"], rbacPerm)
    ) {
      setUsetiful();
    }
  }, [isLogged, rbacPerm]);

  return (
    <Fragment>
      <ToastContainer
        position="bottom-left"
        autoClose={3000}
        hideProgressBar
        closeButton
      />

      <Router>
        <Routes>
          <Route
            path="/"
            element={
              localStorage.getItem("token") ? (
                <Home
                  checkSubscriptionDialogOnRouteChange={
                    checkSubscriptionDialogOnRouteChange
                  }
                />
              ) : (
                <Navigate
                  replace
                  to="/auth/login"
                  state={{
                    from:
                      window.location.pathname != "/auth/login"
                        ? window.location.href.split(window.location.origin)[1]
                        : null,
                    ref: new URLSearchParams(window.location.search).get("ref"),
                  }}
                />
              )
            }
          >
            <Route index element={<Navigate replace to={"/home"} />} />
            <Route path="home" element={<HomePage />} />
            <Route path="organisation">
              <Route
                index
                element={<Navigate replace to="/organisation/facility" />}
              />
              <Route
                path="disclosures"
                element={
                  <RbacRoute
                    allowedPermissions={["READ_DISCLOSURE"]}
                    component={<DisclosureHome />}
                    requiredPlansPermission={"DISCLOSURE"}
                  />
                }
              />
              <Route
                path="facility"
                element={
                  <RbacRoute
                    allowedPermissions={["READ_ALL_FACILITIES"]}
                    component={<BusinessUnitList />}
                    requiredPlansPermission={"FACILITY"}
                  />
                }
              />
              <Route
                path="facilityconfigurations"
                element={
                  <RbacRoute
                    allowedPermissions={["CREATE_FACILITY"]}
                    component={<BusinessUnitHome />}
                    requiredPlansPermission={"FACILITY"}
                  />
                }
              />
              <Route
                path="facilityconfigurations/:id"
                element={
                  <RbacRoute
                    allowedPermissions={["UPDATE_FACILITY"]}
                    component={<BusinessUnitHome />}
                    requiredPlansPermission={"FACILITY"}
                  />
                }
              />
              {/* <Route path="employee" element={<EmployeeList />} /> */}
              {/* <Route path="add-employee" element={<EmployeeHome />} />
              <Route path="add-employee/:id" element={<EmployeeHome />} /> */}
              <Route path="employee" element={<Employee />}>
                <Route
                  index
                  element={
                    <Navigate
                      replace
                      to="/organisation/employee/employee-list"
                    />
                  }
                />
                <Route
                  path="employee-list"
                  element={
                    <RbacRoute
                      allowedPermissions={["READ_EMPLOYEE_LIST"]}
                      component={<EmployeeList />}
                      requiredPlansPermission={"USER"}
                    />
                  }
                />
                <Route
                  path="add-employee"
                  element={
                    <RbacRoute
                      allowedPermissions={["CREATE_EMPLOYEE"]}
                      component={<EmployeeHome />}
                      requiredPlansPermission={"USER"}
                    />
                  }
                />
                <Route
                  path="edit-employee/:id"
                  element={
                    <RbacRoute
                      allowedPermissions={["READ_EMPLOYEE", "UPDATE_EMPLOYEE"]}
                      component={<EmployeeHome />}
                      requiredPlansPermission={"USER"}
                    />
                  }
                />
              </Route>
            </Route>
            <Route path="datasource">
              <Route
                index
                element={
                  <Navigate replace to="/datasource/customemissionfactor" />
                }
              />
              <Route
                path="customemissionfactor"
                element={
                  <RbacRoute
                    allowedPermissions={["READ_EMISSION_FACTOR"]}
                    component={<CustomEmissionList />}
                    requiredPlansPermission={"EMISSIONS"}
                  />
                }
              />
              <Route
                path="customemission"
                element={
                  <RbacRoute
                    allowedPermissions={["CREATE_EMISSION_FACTOR"]}
                    component={<CustomEmissionCreation />}
                    requiredPlansPermission={"EMISSIONS"}
                  />
                }
              />
              <Route
                path="customemission/:id"
                element={<CustomEmissionCreation />}
              />
              <Route
                path="standardemissionfactor"
                element={<SourceEmissionFactor />}
              />
            </Route>

            <Route path="auditsummary" element={<AuditSummaryHome />} />

            <Route path="log">
              <Route index element={<Navigate replace to="/log/emissions" />} />
              <Route
                path="logemissions"
                element={
                  <RbacRoute
                    allowedPermissions={["CREATE_EMISSION"]}
                    component={<EmissionsHome />}
                    requiredPlansPermission={"EMISSIONS"}
                  />
                }
              />
              <Route
                path="emissions"
                element={
                  <RbacRoute
                    allowedPermissions={["READ_EMISSIONS"]}
                    component={<EmissionList />}
                    requiredPlansPermission={"EMISSIONS"}
                  />
                }
              />
              <Route path="bulkupload" element={<FileUploadPage />} />

              {/* <Route path="businessunitconfigurations"  element={<BusinessUnitHome />} /> 
            <Route path="businessunitconfigurations/:id"  element={<BusinessUnitHome />} /> */}
            </Route>
            <Route path="partners">
              <Route
                index
                element={<Navigate replace to="/partners/suppliers" />}
              />
              <Route path="suppliers">
                <Route
                  index
                  // element={<SupplierHome />}
                  element={
                    <Navigate replace to="/partners/suppliers/dashboard" />
                  }
                />
                <Route path="list" element={<SupplierHome />} />
                <Route path="dashboard" element={<SupplierHome />} />
                <Route path="reports" element={<SupplierHome />} />
                <Route path="create" element={<SupplierCreation />} />
                <Route path="bulk-upload" element={<SupplierBulkUpload />} />
              </Route>
              <Route path="customers">
                <Route
                  index
                  element={<Navigate replace to="/partners/customers/list" />}
                />
                <Route path="list" element={<CustomerHome />} />
                {/* <Route path="dashboard" element={<CustomerHome />} />
                <Route path="reports" element={<CustomerHome />} /> */}
                <Route path="submit-data" element={<DataCollection />} />
              </Route>
            </Route>

            <Route path="cat-map" element={<CategoryMapping />} />

            <Route path="settings">
              <Route
                index
                element={<Navigate replace to="/settings/subscription" />}
              />
              {/* <Route
                path="organisation-information"
                element={
                  <RbacRoute
                    allowedPermissions={["READ_EMPLOYEE_LIST"]}
                    component={<OrganisationInfomation />}
                  />
                }
              /> */}
              {/* <Route
                path="organisation-preferences"
                element={
                  <RbacRoute
                    allowedPermissions={["UPDATE_EMPLOYEE"]}
                    component={<OrganisationPreference />}
                  />
                }
              /> */}
              <Route path="subscription" element={<SubscriptionSettings />} />
              <Route
                path="organisationInformation"
                element={<OrganisationInfomation />}
              />
              <Route
                path="organisationpreference"
                element={<OrganisationPreference />}
              />
              <Route path="security" element={<Security />} />
            </Route>

            <Route path="dashboard" element={<DashBoard />} />
            <Route
              path="targets"
              element={
                <RbacRoute
                  allowedPermissions={["READ_TARGET_LIST"]}
                  component={<TargetList />}
                  requiredPlansPermission={"TARGETS"}
                />
              }
            />
            <Route
              path="target"
              element={
                <RbacRoute
                  allowedPermissions={["CREATE_TARGET"]}
                  component={<TargetHome />}
                  requiredPlansPermission={"TARGETS"}
                />
              }
            />
            <Route
              path="target/:id"
              element={
                <RbacRoute
                  allowedPermissions={["UPDATE_TARGET"]}
                  component={<TargetHome />}
                  requiredPlansPermission={"TARGETS"}
                />
              }
            />
            <Route path="emissiontarget" element={<EmissionTarget />} />
            <Route path="reports" element={<CreateReport />} />
            <Route path="/resourcecentre" element={<TrainingVideo />} />
            <Route
              path="assets"
              element={
                <RbacRoute
                  allowedPermissions={["READ_ASSET_LIST"]}
                  component={<AssetList />}
                  requiredPlansPermission={"ASSETS"}
                />
              }
            />
            <Route
              path="asset"
              element={
                <RbacRoute
                  allowedPermissions={["CREATE_ASSET"]}
                  component={<AssetHome />}
                  requiredPlansPermission={"ASSETS"}
                />
              }
            />
            <Route
              path="asset/:id"
              element={
                <RbacRoute
                  allowedPermissions={["UPDATE_ASSET"]}
                  component={<AssetHome />}
                  requiredPlansPermission={"ASSETS"}
                />
              }
            />
            <Route
              path="offsets"
              element={
                <RbacRoute
                  allowedPermissions={["READ_OFFSET_LIST"]}
                  component={<ProjectAndOffsetsList />}
                  requiredPlansPermission={"OFFSETS"}
                />
              }
            />
            <Route
              path="offset"
              element={
                <RbacRoute
                  allowedPermissions={["CREATE_OFFSET"]}
                  component={<ProjectAndOffsetsCreation />}
                  requiredPlansPermission={"OFFSETS"}
                />
              }
            />
            <Route
              path="offset/:id"
              element={
                <RbacRoute
                  allowedPermissions={["CREATE_OFFSET"]}
                  component={<ProjectAndOffsetsCreation />}
                  requiredPlansPermission={"OFFSETS"}
                />
              }
            />
            <Route
              path="audits"
              element={
                <RbacRoute
                  allowedPermissions={["READ_AUDIT_REQUESTS_LIST"]}
                  component={<AuditList />}
                  requiredPlansPermission={"AUDIT"}
                />
              }
              // element={<AuditList />}
            />
            <Route
              path="audit"
              element={
                <RbacRoute
                  allowedPermissions={["READ_AUDIT_REQUESTS_LIST"]}
                  component={<AuditCreation />}
                  requiredPlansPermission={"AUDIT"}
                />
              }
              // element={<AuditCreation />}
            />
            {/* <Route path="Organisation/businessunits"  element={<BusinessUnitList />} />
          <Route path="Organisation/businessunitconfigurations"  element={<BusinessUnitHome />} />
          <Route path="Organisation" element={(<Navigate replace to={"/auth"} />)} /> */}
          </Route>
          <Route
            path="/report-asset"
            element={
              localStorage.getItem("token") ? (
                <RbacRoute
                  allowedPermissions={["READ_REPORT_ASSETS"]}
                  component={<ReportAsset />}
                  requiredPlansPermission={""}
                />
              ) : (
                <Navigate
                  replace
                  to="/auth/login"
                  state={{
                    from:
                      window.location.pathname != "/auth/login"
                        ? window.location.href.split(window.location.origin)[1]
                        : null,
                  }}
                />
              )
            }
          />
          <Route path="/auth" element={<Auth />}>
            <Route index element={<Navigate replace to="/auth/login" />} />
            <Route path="login" element={<Login />} />
            <Route
              path="register-supplier"
              element={<SupplierRegistration />}
            />

            <Route path="audit-request" element={<ExternalVerifierLogin />} />
            <Route path="register" element={<Register />} />
            <Route path="verify-email/:key" element={<VerifyEmail />} />
          </Route>
          <Route path="/coorporate-onboarding" element={<OnBoarding />} />
          <Route
            path="/plans"
            element={<SubscriptionLandingPage formIframe={true} />}
          />

          {/* <Route element={<Home />} >
          <Route index element={<Empty/>} />
          <Route path="/organisation/businessunits"  element={<BusinessUnitList />} />
          <Route path="/organisation/businessunitconfigurations"  element={<BusinessUnitHome />} />
        </Route> */}
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/verifyotp" element={<VerifyRegister />} />

          <Route path="/verifyaccount" element={<VerifyAccount />} />
          <Route path="/verifypassword" element={<ForgotPassword />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/resetsuccess" element={<ResetSuccess />} />
          <Route path="/error" element={<Error />} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </Router>
      {openSubscriptionDialog && (
        <SubscriptionLandingPage
          showCloseIcon={true}
          open={openSubscriptionDialog}
          onClose={handleSubscriptionDialogClose}
        />
      )}
    </Fragment>
  );
}
const mapStateToProps = (state: any) => {
  return {
    isLoggedIn: !!state.auth.token,
  };
};

export default connect(mapStateToProps)(App);
